import javaLogo from "../assets/logos/java-original.svg";
import cppLogo from "../assets/logos/cplusplus-original.svg";
import reactLogo from "../assets/logos/react-original.svg";
import springLogo from "../assets/logos/spring-original.svg";
import springBootLogo from "../assets/logos/spring-boot-logo.png"; 
import mongoLogo from "../assets/logos/mongodb-original.svg";
import mysqlLogo from "../assets/logos/mysql-original.svg";
import hibernatelog from "../assets/logos/hibernate-logo.png";
import dockerLogo from "../assets/logos/docker-original.svg";
import renderLogo from "../assets/logos/render-logo.png"; 
import netlifyLogo from "../assets/logos/netlify-original.svg";
import vscodeLogo from "../assets/logos/vscode-original.svg";
import intellijLogo from "../assets/logos/intellij-original.svg";
import postmanLogo from "../assets/logos/postman-original.svg";
import vedanshLogo from "../assets/logos/vedansh-logo.jpg";
import acropolisLogo from "../assets/logos/acropolis-logo.jpg";
import chitchatphoto from "../assets/ProjectPhotos/Chit-Chat-photo.png";
import smartmailphoto from "../assets/ProjectPhotos/SmartMail.png";
import todophoto from "../assets/ProjectPhotos/todo.png";
import canvalogo from "../assets/logos/canva.png";
import figmalogo from "../assets/logos/figma.png";
import workbenchlogo from "../assets/logos/workbench-logo.png";
import githublog from "../assets/logos/github-white.png";
import EduBlogphoto from "../assets/ProjectPhotos/EduBlog.png";
import HMSphoto from "../assets/ProjectPhotos/HMS.png";
import syncspacephoto from "../assets/ProjectPhotos/syncspace.png";
import daycheckphoto from "../assets/ProjectPhotos/daychk.png";



export const Bio = {
  name: "Dakshesh",
  roles: [
    "Backend Developer",
    "Java Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Dakshesh8090",
  resume:
    "https://flowcv.com/resume/sfrsnfru0pe8",
  linkedin: "https://www.linkedin.com/in/dakshesh-singh-sherawat-72681230b/",
  whatsapp: "https://wa.me/917974582621",
  insta: "https://www.instagram.com/daksheshh_/",
};


export const skills = [
  {
    name: "Java",
    image: javaLogo,

  },
  {
    name: "C++",
    image: cppLogo,

  },
  {
    name: "React Js",
    image: reactLogo,

  },
  {
    name: "Spring",
    image: springLogo,

  },
  {
    name: "Spring Boot",
    image: springBootLogo, 

  },
  {
    name: "MongoDB",
    image: mongoLogo,

  },
  {
    name: "MySQL",
    image: mysqlLogo,

  },
  {
    name: "Hibernate",
    image: hibernatelog,

  },
  {
    name: "Docker",
    image: dockerLogo,

  },
  {
    name: "Git/GitHub",
    image: githublog,

  },
  {
    name: "Render",
    image: renderLogo, // placeholder

  },
  {
    name: "Netlify",
    image: netlifyLogo,

  },
  {
    name: "VS Code",
    image: vscodeLogo,
    
  },
  {
    name: "Intellij IDEA",
    image: intellijLogo,
    
  },
  {
    name: "Postman",
    image: postmanLogo,
   
  },
  {
    name: "Workbench",
    image: workbenchlogo,
    
  },
  {
    name: "Canva",
    image: canvalogo,
   
  },
  {
    name: "Figma",
    image: figmalogo,
    
  },
];



export const experiences = [
  {
    id: 0,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
    role: "Frontend Engineer Intern",
    company: "Neurobit",
    date: "June 2023 - Nov 2023",
    desc: "Enhanced user experiences on Neurobit PSG & Hybrid, Portals by resolving bugs & reduced load time by 40%. Built Neurobit Analytics portal using React Js with seamless interaction of REST APIs using AXIOS optimized with React Query. Refactored previous code to TypeScript, updated with new dependency and integrated Vite with Jest for Unit Testing.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",
  },
  {
    id: 1,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "DevOps & Fullstack Engineering Intern",
    company: "Flipr Inovations Pvt. Ltd.",
    date: "Aug 2023 - Oct 2023",
    desc: "Built Flipr Connect Platforms using React Js integrated GraphQL with AXIOS, created High level Design and Figma design. Built Backend with GraphQL and Node JS and connected with MongoDb - Reducing API calls by 20%. Dockerized and automated with Kubernetes & Jenkins CI/CD deployed in AWS-EC2 added Prometheus & Grafana for monitoring.",
    skills: [
      "Docker",
      "Terraform",
      "AWS",
      "EC2",
      "Portainer",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 2,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Rudraksha.jpeg?alt=media&token=8f83f41e-d0a1-486f-9c7f-dd4cd1d09e8d",
    role: "Android Developer Intern",
    company: "Rudraksha Welffare Foundation",
    date: "June 2021 - Oct 2021",
    desc: "• Built RudraShakti - Astrologer App, with MVVM Architecture using Java and Android Studio integrating Firebase SDK. Created One to One video call integration with Socket.IO and Firebase cloud functions and integrated with Retrofit. Created Low Level Design and converted Figma design to XML code.",
    skills: [
      "Android",
      "Java",
      "Kotlin",
      "XML",
      "Node Js",
      "Cloud Firestore",
      "Firebase",
      "Figma",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
  {
    id: 3,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
    role: "Fullstack Externship",
    company: "Flipr",
    date: "June 2023 - July 2023",
    desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
  {
    id: 4,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/gdsc.jpeg?alt=media&token=c162329c-efaa-4be8-a173-8d3f4c48ea70",
    role: "Android Developer",
    company: "DSC KIIT",
    date: "Nov2021 - Present",
    desc: "As an Android developer at the Google Developers Student Club (GDCS), I have had the opportunity to work on exciting projects and collaborate with talented developers who share my passion for technology. Through my involvement with GDCS, I have also had the opportunity to host and participate in numerous events, including hackathons, study jams, and workshops.",
    skills: [
      "Leadership",
      "Mobile Application Development",
      "Kotlin",
      "XML",
      "Figma",
    ],
  },
  {
    id: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributed to different open-source projects and learn from industry experts",
  },
];

export const education = [
  {
    id: 0,
    img: acropolisLogo,
    school: "Acropolis Institute of Technology and Research, Indore",
    date: "Nov 2022 - June 2026",
    grade: "7.96 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Information Technology at Acropolis Institute of Technology and Research, Indore. I have completed 6 semesters and have a CGPA of 7.96. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Information Technology",
  },
  {
    id: 1,
    img: vedanshLogo,
    school: "The Vedansh International School, Indore",
    date: "Apr 2020 - Apr 2021",
    grade: "88.8%",
    desc: "I completed my class 12 high school education at The Vedansh International School, Indore, where I studied Science with Python programming.",
    degree: "CBSE(XII)",
  },
  {
    id: 2,
    img: vedanshLogo,
    school: "The Vedansh International School, Indore",
    date: "Apr 2018 - Apr 2019",
    grade: "75%",
    desc: "I completed my class 10 education at The Vedansh International School, Indore, where I studied Science.",
    degree: "CBSE(X)",
  },
];

export const projects = [
  {
    id: 13,
    title: "SyncSpace",
    date: "Aug 2025 - Oct 2025",
    description:
      " A collaborative workspace that enables teams to plan, assign, and track work seamlessly while integrating real-time communication, issue tracking, and subscription-based features.",
    image:
      syncspacephoto,
    tags: ["SpringBoot", "React.js", "MySQL" ],
    github: "https://github.com/Dakshesh8090/SyncSpace",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 12,
    title: "Day Check",
    date: "Nov 2025 - Nov 2025",
    description:
      "It's a weather forecasting web app that provides real-time weather updates, forecasts based on user location, utilizing a sleek and intuitive interface ",
    image:
      daycheckphoto,
    tags: ["React.js", "Axios"],
    category: "web app",
    github: "https://github.com/Dakshesh8090/weather_app",
    webapp: "https://daychk.netlify.app",
  },
  {
    id: 11,
    title: "Chit Chat App",
    date: "Jun 2025 - July 2025",
    description:
      "Chit Chat is a real-time messaging platform that lets users connect instantly in private chat rooms. Users can create or join rooms and enjoy seamless, low-latency conversations powered by WebSockets, ensuring messages are delivered in real time without page refreshes.",
    image:
      chitchatphoto,
    tags: [
      "java",
      "React Js",
      "MongoDb",
      "Spring Boot",
      "Tailwind CSS",
      "WebSocket",
      "Render",
      "Docker",
      "Netlify"
    ],
    category: "web app",
    github: "https://chitchatmessage.netlify.app/",
    webapp: "",
  },
  {
    id: 9,
    title: "Smart Mail Suite",
    date: "April 2025 - Jun 2025",
    description:
      "SmartMailSuite is an AI-powered email assistant, a chrome extension that helps you draft intelligent, context-aware replies effortlessly. It streamlines your workflow by understanding the context and tone of incoming messages and generating tailored replies with a single click.",
    image:
      smartmailphoto,
    tags: [
      "Docker",
      "AWS",
      "DuckDNS",
      "Eslint",
      "Husky",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
    ],
    category: "web app",
    github: "https://github.com/Dakshesh8090/SmartMailSuite",
    downloadextension: "https://drive.google.com/drive/folders/1lKPqRB5XT-jnb4Y-J6VI3mgR7V0Cilx4?usp=sharing",
  },
  {
    id: 3,
    title: "To-Do Application",
    date: "Nov 2024 - Dec 2024",
    description:
      "This is a basic user friendly To-Do Application where you can perform CRUD operations like: -add task -delete task -update task -view task",
    image:
      todophoto,
    tags: ["JSP", "MySQL", "Java", "Spring Boot", "Spring MVC"],
    category: "web app",
    github: "https://github.com/Dakshesh8090/ToDoApplication",
  },
  {
    id: 1,
    title: "Educational Blog Website",
    date: "Jan 2025 - Mar 2025",
    description:
      "Educational Blog is a user-friendly educational blog platform designed to simplify academic collaboration among students. It provides a centralized space where students can upload, organize, and access notes in blog format across different categories, making studying more efficient and community driven.",
    image:
      EduBlogphoto,
    tags: [
      "JSP",
      "Servlet",
      "MySQL",
      "Java",
      "Botstrap",
      "Html",
      "CSS",
    ],
    category: "web app",
    github: "https://github.com/Dakshesh8090/Educational-Blog",
  },
  {
    id: 2,
    title: "Hospital Management System",
    date: "Aug 2024 - Sept 2024",
    description:
      "A Hospital Management System (HMS) is a comprehensive software solution designed to streamline and automate the administrative, clinical, and financial operations of a healthcare facility. It serves as a centralized platform that integrates various functions such as patient registration, appointment scheduling, doctor's registration.",
    image:
      HMSphoto,
    tags: ["Java", "Jdbc", "MySQL"],
    github: "https://github.com/Dakshesh8090/Hospital-Management-System",
  },

  

    /*
  {
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://camo.githubusercontent.com/84ac6ab6f378348ef28d8184062b7e9e3511a1252ae3966eaa49e8e998f732a7/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
  },
  {
    id: 6,
    title: "Breaking Bad",
    date: "Jun 2021",
    description:
      "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    image:
      "https://camo.githubusercontent.com/937774368308a82419f53dd6eeb4a8675780e119636488b4e3cfe5d34859a72a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    tags: ["React Js", "API", "Axios", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Breaking-Bad",
    webapp: "https://breaking-bad-webapp.netlify.app",
  },
  {
    id: 7,
    title: "Quiz App",
    date: "Dec 2020 - Jan 2021",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: "android app",
    github: "https://github.com/rishavchanda/Quiz-Earn",
    webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
  {
    id: 8,
    title: "Face Recognition",
    date: "Jan 2021",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "https://dontrepeatyourself.org/media/face-recognition-with-python-dlib-and-deep-learning_cezKZBj.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  },
  */
];

